import { Routes, RouterModule } from '@angular/router';
import { HomePageComponent } from './_pages/home-page/home-page.component';
import { LoginPageComponent } from './_pages/login-page/login-page.component';
import { ProtocoloPageComponent } from './_pages/protocolo-page/protocolo-page.component';
import { ProtocoloNaoFiscalComponent } from './_pages/protocolo-nao-fiscal/protocolo-nao-fiscal.component';
import { AuthGuard } from './_guards';
import { PopUpColetoresComponent } from './_components/popupColetores/popupColetores.component';
import { ConfirmacaoProtocoloComponent } from './_components/confirmacaoProtocolo/confirmacaoProtocolo.component';
import {
  ConfirmacaoProtocoloFundoFixoComponent
} from './_components/confirmacaoProtocoloFundoFixo/confirmacaoProtocoloFundoFixo.component';
import { ConfirmacaoDuplicidadeFiscalComponent } from './_components/confirmacaoDuplicidadeFiscal/confirmacaoDuplicidadeFiscal.component';
import { PopupMessagesComponent } from './_components/popup-messages/popup-messages.component';
import { PopupMessagesNewStyleTestComponent } from './_components/popup-messages-new-style-test/popup-messages-new-style-test.component';
import { PopupAdiantamentosComponent } from './_components/popup-adiantamentos/popup-adiantamentos.component';
import { PopupColetorCustosComponent } from './_components/popup-coletor-custos/popup-coletor-custos.component';
import { PopupFiltroPesquisaComponent } from './_components/popup-filtro-pesquisa/popup-filtro-pesquisa.component';
import { PopupTermoAdiantamentoComponent } from './_components/popup-termo-adiantamento/popup-termo-adiantamento.component';
import { AusenciaTemporariaPageComponent } from './_pages/ausencia-temporaria-page/ausencia-temporaria-page.component';
import { AcompanhamentoPageComponent } from './_pages/acompanhamento-page/acompanhamento-page.component';
import { PageNotFoundComponent } from './_pages/page-not-found/page-not-found.component';
import { ListaCentroCustosComponent } from './_components/lista-centro-custos/lista-centro-custos.component';
import { ListaDiagramaRedeComponent } from './_components/lista-diagrama-rede/lista-diagrama-rede.component';
import { ListaOrdemInternaComponent } from './_components/lista-ordem-interna/lista-ordem-interna.component';
import { NgModule } from '@angular/core';
import { ProtocoloFiscalComponent } from './_pages/protocolo-fiscal/protocolo-fiscal.component';
import { PopupCentroLogisticoComponent } from './_components/popup-centro-logistico/popup-centro-logistico.component';
import { PopupProdutosComponent } from './_components/popup-produtos/popup-produtos.component';
import { RastrearProtocoloPageComponent } from './_pages/rastrear-protocolo-page/rastrear-protocolo-page.component';
import { AprovacaoComercialComponent } from './_pages/aprovacao-comercial/aprovacao-comercial.component';
import { BrowserUtils } from '@azure/msal-browser';
import { ModalAvisosNfComponent } from './_components/modal-avisos-nf/modal-avisos-nf.component';

const appRoutes: Routes = [
  { path: '', component: LoginPageComponent },
  { path: 'login', component: LoginPageComponent },
  { path: 'popupColeteres', component: PopUpColetoresComponent },
  { path: 'popupAdiantamentos', component: PopupAdiantamentosComponent },
  { path: 'popupColetorCustos', component: PopupColetorCustosComponent },
  { path: 'popupFiltroPesquisa', component: PopupFiltroPesquisaComponent },
  { path: 'popupCentroLogistico', component: PopupCentroLogisticoComponent },
  { path: 'popupConfirmacao', component: ConfirmacaoProtocoloComponent },
  { path: 'popupConfirmacaoFundoFixo', component: ConfirmacaoProtocoloFundoFixoComponent },
  { path: 'popupConfirmacaoDuplicidadeFiscal', component: ConfirmacaoDuplicidadeFiscalComponent },
  { path: 'popupProdutos', component: PopupProdutosComponent },
  { path: 'popupMessage', component: PopupMessagesComponent },
  { path: 'popupMessageNewStyleTest', component: PopupMessagesNewStyleTestComponent },
  { path: 'ModalAvisosNf', component: ModalAvisosNfComponent },
  { path: 'popTermoAdiantamento', component: PopupTermoAdiantamentoComponent },
  { path: 'listaCentroCustos', component: ListaCentroCustosComponent },
  { path: 'listaDiagramaRede', component: ListaDiagramaRedeComponent },
  { path: 'listaOrdemInterna', component: ListaOrdemInternaComponent },
  { path: 'home', component: HomePageComponent, canActivate: [AuthGuard] },
  { path: 'protocolo', component: ProtocoloPageComponent, canActivate: [AuthGuard] },
  { path: 'protocolo-fiscal', component: ProtocoloFiscalComponent, canActivate: [AuthGuard] }, // AuthGuardSpecial
  { path: 'protocolo-fiscal/:idProtocolo', component: ProtocoloFiscalComponent, canActivate: [AuthGuard] },
  { path: 'ausencia-temporaria', component: AusenciaTemporariaPageComponent, canActivate: [AuthGuard] },
  { path: 'acompanhamento', component: AcompanhamentoPageComponent, canActivate: [AuthGuard] },
  { path: 'protocolo-naofiscal', component: ProtocoloNaoFiscalComponent },
  { path: 'protocolo-naofiscal/:idProtocolo', component: ProtocoloNaoFiscalComponent, canActivate: [AuthGuard] },
  { path: 'rastrear-protocolo', component: RastrearProtocoloPageComponent, canActivate: [AuthGuard] },
  { path: 'aprovacao-comercial', component: AprovacaoComercialComponent, canActivate: [AuthGuard] },
  // otherwise redirect to home
  { path: '**', pathMatch: 'full', component: PageNotFoundComponent }

];

const isIframe = window !== window.parent && !window.opener;

@NgModule({
  imports: [RouterModule.forRoot(appRoutes, {initialNavigation: !BrowserUtils.isInIframe() && !BrowserUtils.isInPopup() ? "enabled" : "disabled" })],
  exports: [RouterModule],
})

export class AppRoutingModule { }
